import { createContext } from "react";
export const SelectNodeContext = createContext(null);
